// extracted by mini-css-extract-plugin
export var externalLinkIcon = "ExternalLinkIcon-module__externalLinkIcon___JZbA0";